export const type = state => (key) => {
  return state._[key].type
}

export const data = state => (key) => {
  return state._[key].data
}

export const getList = state => {
  return state.list
}
